<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page1'"
      :class="['page page1', $store.state.show === 'page1' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <div :class="['screen screen1', $store.state.screen === 'screen1' ? 'active' : '' ? 'active' : '']">
            <!-- <img src="./images/p1-p1-yanzi.png" alt="" class="p1-yanzi abs" /> -->
            <img src="./images/p1-p1-biaoti.png" alt="" class="p1-biaoti abs" />
            <img src="./images/p1-p1-logo.png" alt="" class="p1-logo abs" />
            <img src="./images/p1-p1-chuan.png" alt="" class="p1-chuan abs" />
          </div>

          <div :class="['screen screen1-0', $store.state.screen === 'screen1' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p1-p1-btn.png" @click="showDaoyu" alt="" class="p1-btn abs" />
          </div>
          
          <div :class="['screen screen2', $store.state.screen === 'screen2' ? 'active' : '' ? 'active' : '']">
            <div class="p2-juanzhou abs">
              <div class="p2-text-wrap">
                <!-- <div class="p2-title ">导 语</div>
                <div class="p2-text ">明崇祯十年（1637年），徐霞客游历广西，曾途经世界上第一条人工运河——灵渠，用“巨舫鳞次”形容当时盛景。2022年8月28日，平陆运河建设正式开始，计划工期54个月，这是西部陆海新通道骨干工程，对推动广西及西南地区发展具有战略意义。</div>
                <div class="p2-text ">当旅行达人徐霞客遇到平陆运河，会有怎样的故事？下面跟随他的穿越之旅，一起提前畅游平陆运河。</div> -->
              </div>
            </div>
          </div>

          <img src="./images/p1-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>

        <img :class="['tips-up abs opacity', $store.state.screen === 'screen2' ? 'active' : '' ? 'active' : '']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "Page1",
  components: {},
  data() {
    return {
    };
  },
  methods: {
    // 下一页
    // nextPage() {
    //   this.$store.dispatch("setPageFn", "page2");
    // },
    // 显示导语
    showDaoyu() {
      this.$store.dispatch("setScreenFn", "screen2");
    },
    animate() {
      const t = new TimelineMax();
      const box = $(".page1");
      const p1 = box.find(".p1-biaoti");
      const p2 = box.find(".p1-logo");
      const p3 = box.find(".p1-btn");
      const p4 = box.find(".p1-chuan");
      const p5 = box.find(".p1-yanzi");
      const p6 = box.find(".p1-molihua");
      t.set(p1, { y: 50, opacity: 0 })
        .set(p2, { y: 50, opacity: 0 })
        .set(p3, { scale: 0, opacity: 0 })
        .set(p4, { x: -100, y: 60, opacity: 0 })
        .set(p5, { x: 100, y: -60, opacity: 0 })
        .staggerTo([p1, p2, p5], 0.6, { y: 0, x: 0, opacity: 1, scale: 1, delay: 0.3 }, 0.2, "ease-out")
        .staggerTo([p3, p4], 0.6, { y: 0, x: 0, opacity: 1, scale: 1, delay: 0.6 }, 0.3, "ease-out")
    },
    // 当前页面执行
    async pageOperate() {
      this.animate();
    },
  },
  mounted() {
    // this.pageOperate();
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page1") {
        this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page1 {
  background: url("./images/p1-p1-bg.gif") top center no-repeat;
  background-size: 100% auto;

  .screen2.active {
    .p2-juanzhou {
      height: 1174px;
    }
  }

  .tips-up {

    transition: opacity 0.5s ease-out 1.2s;
  }

  .content {

    .screen1-0.active {
      z-index: 50;
    }

    .screen2.active {
      z-index: 50;
    }

    .p1-yanzi {
      top: 45px;
      right: 50px;
      width: 123px;
    }

    .p1-biaoti {
      top: 204px;
      width: 647px;
      @include cl();
    }

    .p1-logo {
      top: 490px;
      width: 417px;
      @include cl();
    }

    .p1-btn {
      top: 792px;
      width: 317px;
      left: 230px;
      z-index: 20;
    }

    .p1-chuan {
      top: 978px;
      left: 0;
      width: 454px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 40;
    }
    .p2-juanzhou {
      background: url("./images/p1-p2-juanzhou.png") top center no-repeat;
      background-size: 100% auto;
      width: 728px;
      // height: 1048px;
      top: 35px;
      @include cl();
      z-index: 11;
      height: 0;
      overflow: hidden;
      transition: height 1s ease-out 0.2s;

      .p2-text-wrap {
        width: 508px;
        margin: 0 auto;
        padding-top: 106px;
      }

      .p2-title {
        font-size: 64px;
        font-weight: bolder;
        color: #eb4500;
        text-align: center;
        padding-bottom: 65px;
        line-height: 1;
      }
      .p2-text {
        font-size: 30px;
        font-weight: bolder;
        color: #945529;
        line-height: 1.8;
        text-indent: 60px;
      }
    }
  }
}
</style>
